export default __webpack_public_path__ + "static/media/JULYDOM2025.539842e0.png";